import IconCursor from '@/assets/svg/cursor.svg?react';
import { useAppearanceConfigModelStore } from '@/models/appearance-config/appearanceConfig';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { AppTheme } from '@/shared/constant/AppTheme';
import { Button, Divider, Tooltip } from 'aui';
import classNames from 'clsx';

export function CursorCustomRender({ openCursor }: { openCursor: () => void }) {
  const appTheme = useAppearanceConfigModelStore((x) => x.appTheme);

  const isDarkTheme = appTheme === AppTheme.Dark;

  const formatMessage = useClientI18nModelStore((x) => x.clientI18n);

  return (
    <div className={classNames('mt-5 text-base font-400')}>
      <div>
        <div className="flex items-center justify-between">
          <div>{formatMessage('api.action.mcp.modal.cursor.copy')}</div>
          <Tooltip title={formatMessage('api.action.mcp.modal.cursor.version')}>
            <Button
              size="small-plus"
              icon={<IconCursor className="h-[14px] w-[14px]" />}
              onClick={openCursor}
              className={classNames(
                'flex items-center',
                isDarkTheme ? 'bg-white text-black' : 'bg-black text-white',
              )}
            >
              <span className="pl-1">
                {formatMessage('api.action.mcp.modal.cursor.button.text')}
              </span>
            </Button>
          </Tooltip>
        </div>
        <Divider
          className={classNames('text-base text-color-tertiary')}
          orientation="left"
          orientationMargin={0}
        >
          {formatMessage('api.action.mcp.modal.cursor.or')}
        </Divider>
        <div>{formatMessage('api.action.mcp.modal.cursor.manualCopy')}</div>
      </div>
    </div>
  );
}
